import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";
import { API, useAuthedApi } from "./api";

export const DEFAULT_BRANDING = {
  logo_url: "", brand_name: "CarSaleMarket.com", pencils_on: true, default_theme: "dark", brand_color: "", brand_font: "Cormorant Garamond",
  advertise: { text: "Advertise With Us", link: "/advertise", color: "" },
  invest: { text: "Invest With Us", link: "/invest", color: "" },
};

const SiteCtx = createContext({ branding: DEFAULT_BRANDING, owner: null, me: null, isAdmin: false, canEdit: false });

export function SiteProvider({ children }) {
  const { isSignedIn } = useAuth();
  const api = useAuthedApi();
  const [branding, setBranding] = useState(DEFAULT_BRANDING);
  const [owner, setOwner] = useState(null);
  const [me, setMe] = useState(null);

  useEffect(() => {
    axios.get(`${API}/settings/branding`).then((r) => setBranding(r.data)).catch(() => {});
    axios.get(`${API}/settings/owner`).then((r) => setOwner(r.data)).catch(() => {});
  }, []);
  const refreshMe = useCallback(() => (isSignedIn ? api("get", "/me").then(setMe).catch(() => setMe(null)) : setMe(null)), [isSignedIn, api]);
  useEffect(() => { refreshMe(); }, [isSignedIn]); // eslint-disable-line react-hooks/exhaustive-deps

  const isAdmin = me?.role === "admin";
  const value = { branding, setBranding, owner, setOwner, me, setMe, refreshMe, isAdmin, canEdit: isAdmin && branding.pencils_on !== false };
  return <SiteCtx.Provider value={value}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);
